<template>
    <div>
        <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="list-item, list-item, list-item"
            v-if="loading"
        ></v-skeleton-loader>
        <v-list v-if="!loading && reschedules">
            <v-list-item v-for="reschedule in reschedules" :key="reschedule.id">
                <v-list-item-content class="py-1">
                    <BookingCancelledLesson
                        @input="$emit('input', reschedule)"
                        :type="reschedule.type"
                        :instrument="reschedule.instrument"
                        :duration="reschedule.duration"
                        :event="reschedule.group_event"
                        :reschedule_minutes="reschedule.reschedule_minutes"
                        :reschedule_pass="reschedule.reschedule_pass"
                        :dateTime="
                            globalMomentFullDateAtTimeShort(
                                reschedule.starts_at
                            )
                        "
                /></v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import BookingCancelledLesson from "./BookingCancelledLesson.vue";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    components: {
        BookingCancelledLesson,
    },
    props: {
        reschedules: {
            type: Array,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
